import { createSlice } from '@reduxjs/toolkit'
import * as asyncActions from './releaseNotes.asyncActions'

const initialState = {
	allReleaseNotes: [],
	shouldFetchReleaseNotes: true,
	releaseNoteModal: null,
	releaseNoteToBeDeleted: null,
	shouldDisableAddButton: true,
	isReleaseNoteDeleted: false,
}

const slice = createSlice({
	name: 'releaseNotes',
	initialState,

	reducers: {
		setShouldFetchReleaseNotes(state, action) {
			state.shouldFetchReleaseNotes = action.payload
		},
		setSelectedReleaseNoteModal(state, action) {
			state.releaseNoteModal = action.payload || null
		},
		setReleaseNoteToBeDeleted(state, action) {
			state.releaseNoteToBeDeleted = action.payload || null
		},
		setShouldDisableAddButton(state, action) {
			state.shouldDisableAddButton = action.payload
		},
		setIsReleaseNoteDeleted(state, action) {
			state.isReleaseNoteDeleted = action.payload
		},
	},

	extraReducers: (builder) => {
		builder.addCase(
			asyncActions.fetchAllReleaseNotes.fulfilled,
			(state, action) => {
				state.allReleaseNotes =
					(action.payload && action.payload.data) ||
					initialState.allReleaseNotes
			}
		)
	},
})

export default slice

export const { name, actions, reducer } = slice
